import { render, staticRenderFns } from "./el-radio.vue?vue&type=template&id=0b0ce5c6&scoped=true"
import script from "./el-radio.vue?vue&type=script&lang=js"
export * from "./el-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0ce5c6",
  null
  
)

export default component.exports